import React from "react";

import styled from "@emotion/styled";

const EnvelopeIcon = ({
    color = "#05235f",
    hoverColor = color,
    innerColor = "white",
}) => {
    const SVG = styled.svg`
        fill: ${color};

        &:hover {
            fill: ${hoverColor};
        }
    `;
    return (
        <SVG
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 46 46"
        >
            <path
                id="envelope-open-text-regular"
                d="M35.212,4.312H10.779a.721.721,0,0,0-.719.719v15.2L6.216,17.079a5.637,5.637,0,0,0-.467-.341V5.031A5.034,5.034,0,0,1,10.779,0H35.212a5.034,5.034,0,0,1,5.03,5.031v11.7c-.162.108-.314.225-.467.341L35.93,20.233V5.031A.721.721,0,0,0,35.212,4.312Zm-20.84,6.469a2.151,2.151,0,0,1,2.156-2.156H29.463a2.156,2.156,0,0,1,0,4.313H16.528A2.151,2.151,0,0,1,14.372,10.781Zm0,7.187a2.151,2.151,0,0,1,2.156-2.156H29.463a2.156,2.156,0,0,1,0,4.312H16.528A2.151,2.151,0,0,1,14.372,17.969ZM4.312,24.815V40.969a.721.721,0,0,0,.719.719h35.93a.721.721,0,0,0,.719-.719V24.815L28.924,35.291a9.341,9.341,0,0,1-11.857,0ZM0,21.374A2.687,2.687,0,0,1,4.393,19.3L19.807,31.966a5.024,5.024,0,0,0,6.387,0L41.607,19.3A2.687,2.687,0,0,1,46,21.374l-.009,19.595A5.034,5.034,0,0,1,40.961,46H5.03A5.034,5.034,0,0,1,0,40.969Z"
                fill="#05235f"
            />
        </SVG>
    );
};

export default EnvelopeIcon;
